import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { ClickOutDropDown } from '../../DropDown/ClickOutDropDown';
import CloseIcon from '../../Icons/CloseIcon';
import FilterIcon from '../../Icons/FilterIcon';
import PaginatorDownIcon from '../../Icons/PaginatorDownIcon';
import { TableContext } from '../TableContext';
import TableFilterBoxContentWrapper from './TableFilterBoxContentWrapper';

const DropDownLabel = () => {
  return (
    <DropDownLabelContainer>
      <FilterIcon />
      Filter
      <PaginatorDownIcon />
    </DropDownLabelContainer>
  );
};

interface FilterItemCellProps {
  label: string;
  value: string;
}
const FilterItemCell: React.FC<FilterItemCellProps> = ({ label, value }) => {
  const tableContext = useContext(TableContext);

  const handleRemoveSelectedFilter = (label: string) => {
    const tempActiveFilter = { ...tableContext?.tableSelectedFilter };
    tempActiveFilter[label] = '';
    tableContext?.setTableSelectedFilter({ ...tempActiveFilter });
    tableContext?.handleSetTableFilterRecord({
      ...tempActiveFilter,
      page: 0,
    });
  };

  return (
    <FilterItem>
      {value}
      <IconWrapper
        type='button'
        aria-label={`Remove ${label} filter`}
        onClick={() => handleRemoveSelectedFilter(label)}
      >
        <CloseIcon />
      </IconWrapper>
    </FilterItem>
  );
};

interface TableFilterBoxProps {
  filterControlForm?: React.ReactNode;
}

const TableFilterBox: React.FC<TableFilterBoxProps> = ({
  filterControlForm,
}) => {
  const tableContext = useContext(TableContext);
  const hasSelectedFilters = Object.values(
    tableContext?.tableSelectedFilter ?? {},
  ).some((v) => v !== '');

  return (
    <Container className={hasSelectedFilters ? 'has-gap' : ''}>
      {/* Selected filters */}
      <SelectedFilterArea>
        {Object.entries(tableContext?.tableSelectedFilter || {}).map(
          ([key, value]) => {
            if (value === '') {
              return null;
            }
            return <FilterItemCell key={key} label={key} value={value} />;
          },
        )}
      </SelectedFilterArea>

      {/* Filter dropdown menu */}
      <ClickOutDropDown
        tableFilter
        label={<DropDownLabel />}
        marginTop='12px'
        borderRadius='5px'
        posRight={'0px'}
      >
        <TableFilterBoxContentWrapper>
          {React.Children.map(filterControlForm, (child: any) =>
            React.cloneElement(child, {
              ...child.props,
            }),
          )}
        </TableFilterBoxContentWrapper>
      </ClickOutDropDown>
    </Container>
  );
};

export default TableFilterBox;

const Container = styled.div`
  display: flex;
  /* gap: 12px; */
  /* border: 1px solid blue; */

  &.has-gap {
    gap: 12px;
  }

  @media (max-width: 884px) {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
`;

const DropDownLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 7px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 400;
  color: black;
  font-size: 14px;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};

  &:hover {
    background-color: #fafafa;
  }
`;

const SelectedFilterArea = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  gap: 12px;
  /* border: 1px solid red; */
  width: fit-content;
  /* margin-left: 12px; */

  max-width: 300px;
  /* border: 1px solid blue; */
  overflow-x: auto;

  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

const FilterItem = styled.div`
  display: flex;
  /* align-items: baseline; */
  padding: 7px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 400;
  color: black;
  font-size: 14px;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};

  /* &:first-of-type {
    margin-left: 12px;
  } */
`;

const IconWrapper = styled.button`
  display: grid;
  place-content: center;
  color: #070707;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;
